import '../themeDefaults';

export default ({ datepickerReact }) => ({
  alignLeft: {
    left: 0,
  },
  alignRight: {
    right: 0,
    ...datepickerReact.chevronPointsUp,
    ...datepickerReact.chevronAlignsRight,
  },
  clickOutsideToClose: {
    '&$overlay': {
      position: 'static',
    },
  },
  labelText: {},
  onBottom: {
    '&$labelText': {
      top: datepickerReact.inputHeight + datepickerReact.labelHeight,
    },
    '&$screenReaderLabel': {
      top: datepickerReact.inputHeight,
    },
    '&$usePortal': {
      top: 'auto',
    },
    top: datepickerReact.inputHeight,
  },
  overlay: {
    height: '100%',
    left: 0,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 9999,
  },
  popup: {
    position: 'absolute',
    zIndex: 2,
    ...datepickerReact.chevron,
  },
  screenReaderLabel: {},
  // eslint-disable-next-line
  onTop: {
    bottom: datepickerReact.inputHeight,
    ...datepickerReact.chevronPointsDown,
  },
  onTopError: {
    bottom: 55,
  },
  usePortal: {
    '&$alignLeft': {
      left: 'auto',
    },
    '&$alignRight': {
      right: 'auto',
    },
    '&$onTop': {
      bottom: 'auto',
    },
    '&$overlay': {
      position: 'fixed',
    },
  },
});
